import { environment } from '../../../environments/environment';

export const CONSULTA_RUNT_URL = environment.consultaRuntUrl;
export const CONSULTAS_EXTERNAS_URL = environment.consultasExternasUrl;
